<template>
    <Modal v-model="collectMdl" width="900" :mask-closable="false" :closable="false" class-name="vertical-center-modal agreement">
        <div slot="header"  class="agreement-header">电子合同</div>
        <div class="agreement-main" :style="{'height': newHeight-200 + 'px'}">
            <my-contract :txt="txt" :orderId="orderId" v-if="orderId"></my-contract>
            <div class="buttom">
                <button class="cencel" @click="close">暂不确认</button>
                <button v-if="!affireLoading" @click="affirm">确认合同</button>
                <button v-if="affireLoading">合同确认中...</button>
            </div>
        </div>
    </Modal> 
</template>

<script>
import myContract from "./contract.vue";
export default {
  data() {
    return {};
  },
  components: {
    myContract
  },
  computed: {},
  props: {
    /* 合同主体名称 */
    txt: {
      type: Number,
      default: ''
    },
    collectMdl: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [Number, String]
    },
    affireLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newHeight() {
      return document.documentElement.clientHeight;
    }
  },
  methods: {
    close() {
      this.$emit("closeModel");
    },
    affirm() {
      this.$emit("affirmHandle");
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.agreement {
  .fav-content-right {
    overflow: auto;
  }
  &-header {
    font-size: 20px;
    color: #353838;
    letter-spacing: 4px;
    text-align: center;
    position: relative;
    i {
      position: absolute;
      top: -10px;
      right: 20px;
      cursor: pointer;
      &:after {
        content: "";
        position: absolute;
        top: -10px;
        right: -10px;
        bottom: -10px;
        left: -10px;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  &-main {
    height: 700px;
    overflow-y: auto;
    margin-top: 10px;
    position: relative;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
    .buttom {
      width: 900px;
      height: 90px;
      text-align: center;
      line-height: 90px;
      position: sticky;
      bottom: 0px;
      background: #fff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      box-shadow: 0px 0px 10px 0px #a2a2a8;
      z-index: 10000;
      button {
        padding: 0px 80px;
        background: #f5a623;
        border-radius: 5px;
        color: #fff;
        line-height: 20px;
        &:hover {
          opacity: 0.8;
        }
      }
      .cencel {
        background: #fff;
        color: #f5a623;
        border: 1px solid #f5a623;
        margin-right: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>


    